export default __webpack_public_path__ + "static/media/arrowRightDisabled.e3d9342e.svg";